<div class="mb-6 bg-blue-50 border border-blue-200 rounded-lg px-4 py-4 shadow-sm">
  <div class="flex mb-4">
    <div class="flex flex-col"></div>
    <h2 class="text-xl my-4 font-semibold">{{ question.question }}</h2>
  </div>

  <div class="space-y-4">
    <div *ngFor="let child of question.children; let i = index" class="">
      <app-disable-question-block [question]="child"></app-disable-question-block>
    </div>
  </div>
</div>
